import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import SuggestionRenderer from '../../../FiltersField/renderers/SuggestionRenderer';
import camelize from '@afosto/utils/string/camelize';
import capitalize from '@afosto/utils/string/capitalize';

const CategoryRenderer = ({ value, ...props }) => {
  const intl = useIntl();

  const formattedValue = (value ?? []).reduce(
    (acc, item) => [
      ...acc,
      intl.formatMessage({
        id: `auditCategories.${camelize(item?.toLowerCase())}`,
        defaultMessage: capitalize(item ?? ''),
        description: `audit category ${item}`,
      }),
    ],
    [],
  );

  return <SuggestionRenderer {...props} value={formattedValue} />;
};

CategoryRenderer.propTypes = {
  value: PropTypes.array,
};

CategoryRenderer.defaultProps = {
  value: [],
};

export default CategoryRenderer;
